import mouseCursorIcon from './assets/cursor.png';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

export const FormWelcome = () => {
  return (
    <div {...stylex.props(styles.canvas)}>
      <div {...stylex.props(styles.canvasHeader)}></div>

      <div {...stylex.props(styles.emptyState)}>
        <div {...stylex.props(styles.contentContainer)}>
          <img {...stylex.props(styles.cursorIcon)} src={mouseCursorIcon} alt="Иконка курсора мыши" />
          <div {...stylex.props(styles.textContainer)}>
            <h3 {...stylex.props(styles.emptyStateTitle)}>Добавьте элементы формы</h3>
            <p {...stylex.props(styles.emptyStateDescription)}>
              Нажмите на любой элемент слева и он появится здесь. Рекомендуем начать с логотипа и заголовка
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
